import * as React from "react";
import { Switch, Route } from "react-router-dom";

import Login from "./containers/login/index";
import AddToIci from "./containers/add-to-ici";
import SingleEmailUpload from "./containers/add-to-ici/flows/single-email-upload";
import AttachFromIci from "./containers/attach-from-ici";
import LogOutICI from "./components/log-out-ici/LogOut";
import PreviewPopup from "./containers/attach-from-ici/preview-popup/PreviewPopup";
import { ROUTE } from "./shared/constants/routes";

const Routes: React.FC = () => {
  return (
    <React.Fragment>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact={true} path={ROUTE.LOGIN} component={Login} />
          <Route path={ROUTE.ADD_TO_ICI} component={AddToIci} />
          <Route path={ROUTE.ATTACH_FROM_ICI} component={AttachFromIci} />
          <Route path={ROUTE.LOG_OUT_ICI} component={LogOutICI} />
          <Route path={ROUTE.SINGLE_EMAIL_UPLOAD} component={SingleEmailUpload} />
          <Route path={ROUTE.PREVIEW} component={PreviewPopup} />
        </Switch>
      </React.Suspense>
    </React.Fragment>
  );
};

export default Routes;
